/* tslint:disable */

/**
 */
export class dataContourParam {
    selectedPlan?: number;
    timeSelected?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/data-contour-param.ts